
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleethColour as ObiLightningSleethColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleeth-colour.js';
 
 
 

 
 export const ObiLightningSleethColour = createComponent({
   react: React,
   tagName: 'obi-lightning-sleeth-colour',
   elementClass: ObiLightningSleethColourElement,
   events: {
     
   }
  });
 
 